import { initializeApp } from 'firebase/app'
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  getFirestore,
} from 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyBWSLVURN6R3YlXUPx0INV3z4-IwhdveLk',
  authDomain: 'health-canada-quiz.firebaseapp.com',
  projectId: 'health-canada-quiz',
  storageBucket: 'health-canada-quiz.firebasestorage.app',
  messagingSenderId: '445783180608',
  appId: '1:445783180608:web:940f81d972493b684326a5',
  measurementId: 'G-67LH9EKW6D',
}

const app = initializeApp(firebaseConfig)

initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
})

const db = getFirestore(app)

export { db }
